(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-devis"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX = 20 * 1024 * 1024;
  function init(form) {
    if (form._std) return; form._std = true;
    var msg = form.querySelector('[data-std-msg]'), btn = form.querySelector('[data-std-submit]');
    form.querySelectorAll('[data-std-file]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var drop = inp.closest('[data-std-drop]'), img = drop.querySelector('img'), f = inp.files && inp.files[0];
        if (msg) msg.textContent = '';
        if (f && f.size > MAX) { inp.value = ''; f = null; if (msg) msg.textContent = 'Cette photo dépasse 20 Mo. Choisissez une image plus légère.'; }
        if (f && /^image\//.test(f.type)) { img.src = URL.createObjectURL(f); img.hidden = false; drop.classList.add('is-filled'); }
        else { img.hidden = true; img.removeAttribute('src'); drop.classList.remove('is-filled'); }
      });
    });
    form.addEventListener('submit', function (e) {
      var bad = [].filter.call(form.querySelectorAll('[required]'), function (el) { return el.type === 'file' ? !(el.files && el.files.length) : !String(el.value || '').trim(); })[0];
      if (bad) {
        e.preventDefault();
        if (msg) msg.textContent = bad.type === 'file' ? 'Ajoutez au moins une photo de votre perruque.' : 'Décrivez votre perruque et votre projet.';
        if (bad.type !== 'file') bad.focus();
        return;
      }
      /* Les champs laissés vides ne sont pas envoyés dans la commande */
      [].forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
        var empty = el.type === 'file' ? !(el.files && el.files.length) : !String(el.value || '').trim();
        if (empty) { el.disabled = true; el.dataset.stdOff = '1'; }
      });
      if (btn) { btn.disabled = true; if (btn.dataset.loading) btn.textContent = btn.dataset.loading; }
    });
    window.addEventListener('pageshow', function () {
      if (btn) btn.disabled = false;
      [].forEach.call(form.querySelectorAll('[data-std-off]'), function (el) { el.disabled = false; delete el.dataset.stdOff; });
    });
  }
  function boot(s) { (s || document).querySelectorAll('[data-std]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function sync() {
    document.querySelectorAll('[data-fo-col]').forEach(function (d) {
      if (mq.matches) d.setAttribute('open', '');
      else if (!d.dataset.foTouched) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-fo-col] > summary');
    if (!s) return;
    if (mq.matches) { e.preventDefault(); return; }
    s.parentElement.dataset.foTouched = '1';
  });
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-temoignages"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-tm-track]');
    if (!track) return;
    function step(dir) {
      var card = track.querySelector('.tm-card');
      var w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
      else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var p = root.querySelector('[data-tm-prev]'), n = root.querySelector('[data-tm-next]');
    if (p && !p.dataset.bound) { p.dataset.bound = 1; p.addEventListener('click', function () { step(-1); }); }
    if (n && !n.dataset.bound) { n.dataset.bound = 1; n.addEventListener('click', function () { step(1); }); }
  }
  function all() { document.querySelectorAll('[data-tm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();
})();
